import React from "react";
import "../../css/Wireframe.css";
import Footer from "../../components/Footer";
import Banner from "../../components/Banner";
import Select from "react-select";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Sidebar } from "./../../components/Sidebar";

const API = localStorage.getItem("assethost");
const emailRegex =
  /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)+$/i;
const emailError = "Please enter a valid email address (e.g. name@example.com)";
// eslint-disable-next-line no-useless-escape
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9])) {
    last = id + placeholder1.substring(id.length);
  } else if (id.length >= 10) {
    last = id + placeholder2.substring(id.length);
  } else {
    last = id + ogPlaceholder.substring(id.length);
  }
  return start + last;
}
function formatNationalId(e, state, field, isZimbabwean = true) {
  let currentValue = String(state[field] || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const newState = { ...state, [field]: e };
    return { newPlaceholder, error, newState };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, newState: state };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      newValue = e;
      newPlaceholder = /[A-Z]/.test(e[9])
        ? e + placeholder1.substring(e.length)
        : e + placeholder2.substring(e.length);
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  let newState = { ...state, [field]: newValue };
  return { newPlaceholder, error, newState };
}

export default class Insurance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      registrationNumber: "",
      address1: "",
      address2: "",
      townCityId: 0,
      contactFirstname: "",
      contactSurname: "",
      contactRole: "",
      contactEmail: "",
      contactCellphone: "",
      contactNationality: "",
      contactIdentification: "",
      contactPassportNumber: "",
      contactIdentificationDocument: null,
      contactPassportDocument: null,
      certificateOfIncorporation: null,
      cr14: null,
      username: "",
      password: "",
      passwordConfirm: "",
      errors: {},
      msg: "",
      toastColor: "",
      loading: false,
      companyLookupData: {},
      idPlaceholder: ogPlaceholder,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleId = this.handleId.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.getLookupData = this.getLookupData.bind(this);
  }
  componentDidMount() {
    this.getLookupData();
  }

  isZimbabweanContact() {
    return this.state.contactNationality === "ZW";
  }
  getLookupData() {
    this.setState({ loading: true, msg: "", toastColor: "" });

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "Login details not properly recorded, please return to login screen",
        toastColor: "danger",
        loading: false,
      });
      setTimeout(() => {
        window.location.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      }, 1600);
      return;
    }

    axios
      .get(API + "/register/getcompanydropdownlists", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        this.setState({ companyLookupData: res.data || {} }, this.validate);
      })
      .catch((err) => {
        this.setState({
          msg:
            err?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
          loading: false,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }
  handleChange(e) {
    const { name, value, type, files } = e.target;
    const newValue = type === "file" ? files && files[0] : value;
    this.setState({ [name]: newValue }, this.validate);
  }
  handleSelect(name, option) {
    this.setState(
      {
        [name]: option
          ? option.value
          : typeof option === "string"
          ? option
          : "",
      },
      this.validate
    );
  }
  handleId(val, field = "contactIdentification") {
    const { newPlaceholder, error, newState } = formatNationalId(
      val,
      this.state,
      field,
      this.isZimbabweanContact()
    );
    this.setState(
      {
        [field]: newState[field],
        ...(field === "contactIdentification"
          ? { idPlaceholder: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }
  validate() {
    let s = this.state,
      e = {},
      valid = true;
    if (!s.name || !s.name.trim()) {
      e.name = "Name is required";
      valid = false;
    }
    if (!s.registrationNumber || !s.registrationNumber.trim()) {
      e.registrationNumber = "Registration No is required";
      valid = false;
    }
    if (!s.address1 || !s.address1.trim()) {
      e.address1 = "Address 1 is required";
      valid = false;
    }
    if (!s.townCityId || s.townCityId === 0) {
      e.townCityId = "Town/City is required";
      valid = false;
    }
    if (!s.contactFirstname || !s.contactFirstname.trim()) {
      e.contactFirstname = "Contact Firstname is required";
      valid = false;
    }
    if (!s.contactSurname || !s.contactSurname.trim()) {
      e.contactSurname = "Contact Surname is required";
      valid = false;
    }
    if (!s.contactRole || !s.contactRole.trim()) {
      e.contactRole = "Contact Role is required";
      valid = false;
    }
    if (!s.contactEmail || !s.contactEmail.trim()) {
      e.contactEmail = "Contact Email is required";
      valid = false;
    } else if (!emailRegex.test(s.contactEmail)) {
      e.contactEmail = emailError;
      valid = false;
    }
    if (!s.contactCellphone || !s.contactCellphone.trim()) {
      e.contactCellphone = "Contact Cellphone is required";
      valid = false;
    } else if (!phoneRegex.test(s.contactCellphone)) {
      e.contactCellphone = phoneError;
      valid = false;
    }
    if (!s.contactNationality || !s.contactNationality.trim()) {
      e.contactNationality = "Contact Nationality is required";
      valid = false;
    }
    if (this.isZimbabweanContact()) {
      if (!s.contactIdentification || !s.contactIdentification.trim()) {
        e.contactIdentification = "Contact National ID is required";
        valid = false;
      } else if (!nationalIdRegex.test(s.contactIdentification)) {
        e.contactIdentification = dynamicNationalIdError(
          s.contactIdentification
        );
        valid = false;
      }
    } else {
      if (!s.contactPassportNumber || !s.contactPassportNumber.trim()) {
        e.contactPassportNumber = "Contact Passport Number is required";
        valid = false;
      }
    }
    if (!s.username || !s.username.trim()) {
      e.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      e.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      e.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(s.password)) {
      e.password = passwordError;
      valid = false;
    }
    if (!s.passwordConfirm || !s.passwordConfirm.trim()) {
      e.passwordConfirm = "Password Confirm is required";
      valid = false;
    } else if (s.password !== s.passwordConfirm) {
      e.passwordConfirm = "Passwords do not match";
      valid = false;
    } else if (!passwordRegex.test(s.passwordConfirm)) {
      e.passwordConfirm = passwordError;
      valid = false;
    }
    this.setState({ errors: e });
    return valid;
  }
  handleRegister(e) {
    e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
        loading: false,
      });
      return;
    }
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "Login details not properly recorded, please return to login screen",
        toastColor: "danger",
        loading: false,
      });
      setTimeout(() => {
        window.location.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      }, 1600);
      return;
    }
    let data = new FormData();
    data.append("user.username", this.state.username);
    data.append("user.password", this.state.password);
    data.append("user.userType", "COMPANY");
    data.append(
      "user.fullName",
      [this.state.contactFirstname, this.state.contactSurname].join(" ")
    );
    data.append("user.mobileVerified", "NO");
    data.append("user.activeStatus", "YES");
    data.append("user.emailVerified", "NO");
    data.append("user.isPaidService", "NO");
    data.append("profile.companyName", this.state.name);
    data.append("profile.registrationNumber", this.state.registrationNumber);
    data.append("profile.townCityId", String(this.state.townCityId));
    data.append(
      "profile.physicalAddress",
      [this.state.address1, this.state.address2].filter(Boolean).join(", ")
    );
    data.append("profile.primaryContactFirstName", this.state.contactFirstname);
    data.append("profile.primaryContactSurname", this.state.contactSurname);
    data.append("profile.primaryContactRole", this.state.contactRole);
    data.append(
      "profile.primaryContactIdNumber",
      this.state.contactIdentification
    );
    data.append(
      "profile.primaryPassportNumber",
      this.state.contactPassportNumber
    );
    data.append("profile.primaryContactNumber", this.state.contactCellphone);
    data.append("profile.primaryContactEmail", this.state.contactEmail);
    data.append("profile.companyType", "INSURANCE");
    if (this.state.contactIdentificationDocument)
      data.append(
        "primaryContactIdentityDocument",
        this.state.contactIdentificationDocument
      );
    if (this.state.contactPassportDocument)
      data.append(
        "primaryContactPassportDocument",
        this.state.contactPassportDocument
      );
    if (this.state.certificateOfIncorporation)
      data.append(
        "certificateIncorpFile",
        this.state.certificateOfIncorporation
      );
    if (this.state.cr14) data.append("cr14File", this.state.cr14);
    var self = this;
    axios
      .post(API + "/insurance/save", data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            msg: "Registration successful! Redirecting to login...",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 1700);
        } else {
          self.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
            loading: false,
          });
          if (
            response.data.message &&
            response.data.message.includes("username already exist")
          ) {
            self.setState({
              errors: { ...self.state.errors, username: response.data.message },
            });
          }
        }
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Register as Insurance" />
          {divMsg}
          <form
            className="flex flex-col items-center w-full mt-2 overflow-y-auto"
            autoComplete="off"
            onSubmit={this.handleRegister}
          >
            <div className="w-full max-w-5xl">
              <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                <div className="input-group">
                  <label className="input-group-text">Name</label>
                  <input
                    name="name"
                    className={`form-control ${
                      s.errors.name ? " !border-red-500" : ""
                    }`}
                    value={s.name}
                    onChange={this.handleChange}
                    required
                    autoFocus
                  />
                  {s.errors.name && (
                    <span className="input-group-error">{s.errors.name}</span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Registration No</label>
                  <input
                    name="registrationNumber"
                    className={`form-control ${
                      s.errors.registrationNumber ? " !border-red-500" : ""
                    }`}
                    value={s.registrationNumber}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.registrationNumber && (
                    <span className="input-group-error">
                      {s.errors.registrationNumber}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Address 1</label>
                  <input
                    name="address1"
                    className={`form-control ${
                      s.errors.address1 ? " !border-red-500" : ""
                    }`}
                    value={s.address1}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.address1 && (
                    <span className="input-group-error">
                      {s.errors.address1}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Address 2</label>
                  <input
                    name="address2"
                    className={`form-control ${
                      s.errors.address2 ? " !border-red-500" : ""
                    }`}
                    value={s.address2}
                    onChange={this.handleChange}
                  />
                  {s.errors.address2 && (
                    <span className="input-group-error">
                      {s.errors.address2}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text required">Town/City</label>
                  <Select
                    name="townCityId"
                    value={(s.companyLookupData.townCitys || []).filter(
                      ({ value }) => value === s.townCityId
                    )}
                    onChange={(e) => this.handleSelect("townCityId", e)}
                    className={`form-control ${
                      s.errors.townCityId ? " !border-red-500" : ""
                    }`}
                    required
                    options={s.companyLookupData.townCitys || []}
                  />
                  {s.errors.townCityId && (
                    <span className="input-group-error">
                      {s.errors.townCityId}
                    </span>
                  )}
                </div>
                <div></div>
                <div className="input-group">
                  <label className="input-group-text">Contact Firstname</label>
                  <input
                    name="contactFirstname"
                    className={`form-control ${
                      s.errors.contactFirstname ? " !border-red-500" : ""
                    }`}
                    value={s.contactFirstname}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.contactFirstname && (
                    <span className="input-group-error">
                      {s.errors.contactFirstname}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Contact Surname</label>
                  <input
                    name="contactSurname"
                    className={`form-control ${
                      s.errors.contactSurname ? " !border-red-500" : ""
                    }`}
                    value={s.contactSurname}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.contactSurname && (
                    <span className="input-group-error">
                      {s.errors.contactSurname}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Contact Role</label>
                  <input
                    name="contactRole"
                    className={`form-control ${
                      s.errors.contactRole ? " !border-red-500" : ""
                    }`}
                    value={s.contactRole}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.contactRole && (
                    <span className="input-group-error">
                      {s.errors.contactRole}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Contact Email</label>
                  <input
                    name="contactEmail"
                    className={`form-control ${
                      s.errors.contactEmail ? " !border-red-500" : ""
                    }`}
                    value={s.contactEmail}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.contactEmail && (
                    <span className="input-group-error">
                      {s.errors.contactEmail}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Contact Cellphone</label>
                  <input
                    name="contactCellphone"
                    className={`form-control ${
                      s.errors.contactCellphone ? " !border-red-500" : ""
                    }`}
                    value={s.contactCellphone}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.contactCellphone && (
                    <span className="input-group-error">
                      {s.errors.contactCellphone}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">
                    Contact Nationality
                  </label>
                  <Select
                    name="contactNationality"
                    value={(s.companyLookupData.countrys || []).find(
                      ({ value }) => value === s.contactNationality
                    )}
                    onChange={(option) => {
                      this.handleId("", "contactIdentification");
                      this.handleId("", "contactPassportNumber");
                      this.setState({ idPlaceholder: ogPlaceholder });
                      this.handleSelect("contactNationality", option);
                    }}
                    className={`form-control ${
                      s.errors.contactNationality ? " !border-red-500" : ""
                    }`}
                    required
                    options={s.companyLookupData.countrys || []}
                  />
                  {s.errors.contactNationality && (
                    <span className="input-group-error">
                      {s.errors.contactNationality}
                    </span>
                  )}
                </div>
                {!!s.contactNationality && this.isZimbabweanContact() ? (
                  <div className="input-group">
                    <label className="input-group-text">
                      Contact National ID
                    </label>
                    <input
                      name="contactIdentification"
                      className={`form-control ${
                        s.errors.contactIdentification ? " !border-red-500" : ""
                      }`}
                      value={s.contactIdentification}
                      placeholder={s.idPlaceholder}
                      onChange={(e) =>
                        this.handleId(e.target.value, "contactIdentification")
                      }
                      required
                    />
                    {s.errors.contactIdentification && (
                      <span className="input-group-error">
                        {s.errors.contactIdentification}
                      </span>
                    )}
                  </div>
                ) : !!s.contactNationality ? (
                  <div className="input-group">
                    <label className="input-group-text">
                      Contact Passport Number
                    </label>
                    <input
                      name="contactPassportNumber"
                      className={`form-control ${
                        s.errors.contactPassportNumber ? " !border-red-500" : ""
                      }`}
                      value={s.contactPassportNumber}
                      onChange={(e) =>
                        this.handleId(e.target.value, "contactPassportNumber")
                      }
                      required
                    />
                    {s.errors.contactPassportNumber && (
                      <span className="input-group-error">
                        {s.errors.contactPassportNumber}
                      </span>
                    )}
                  </div>
                ) : null}
                {!!s.contactNationality && (
                  <div className="input-group">
                    <label
                      htmlFor={
                        this.isZimbabweanContact()
                          ? "contactIdentificationDocument"
                          : "contactPassportDocument"
                      }
                      className="input-group-text"
                    >
                      {this.isZimbabweanContact()
                        ? "Contact National ID Document"
                        : "Contact Passport Document"}
                    </label>
                    <input
                      name={
                        this.isZimbabweanContact()
                          ? "contactIdentificationDocument"
                          : "contactPassportDocument"
                      }
                      className="form-control"
                      type="file"
                      id={
                        this.isZimbabweanContact()
                          ? "contactIdentificationDocument"
                          : "contactPassportDocument"
                      }
                      onChange={this.handleChange}
                      accept=".pdf,image/*"
                    />
                  </div>
                )}
                <div className="input-group">
                  <label htmlFor="certOfIncorp" className="input-group-text">
                    Certificate of Incorporation
                  </label>
                  <input
                    name="certificateOfIncorporation"
                    className="form-control"
                    type="file"
                    id="certOfIncorp"
                    onChange={this.handleChange}
                    accept=".pdf,image/*"
                  />
                </div>
                <div className="input-group">
                  <label htmlFor="cr14" className="input-group-text">
                    CR14
                  </label>
                  <input
                    name="cr14"
                    className="form-control"
                    type="file"
                    id="cr14"
                    onChange={this.handleChange}
                    accept=".pdf,image/*"
                  />
                </div>
                <div className="input-group col-span-2">
                  <label className="input-group-text">Username</label>
                  <input
                    name="username"
                    className={`form-control ${
                      s.errors.username ? " !border-red-500" : ""
                    }`}
                    value={s.username}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.username && (
                    <span className="input-group-error">
                      {s.errors.username}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Password</label>
                  <input
                    name="password"
                    type="password"
                    className={`form-control ${
                      s.errors.password ? " !border-red-500" : ""
                    }`}
                    value={s.password}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.password && (
                    <span className="input-group-error">
                      {s.errors.password}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Password Confirm</label>
                  <input
                    name="passwordConfirm"
                    type="password"
                    className={`form-control ${
                      s.errors.passwordConfirm ? " !border-red-500" : ""
                    }`}
                    value={s.passwordConfirm}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.passwordConfirm && (
                    <span className="input-group-error">
                      {s.errors.passwordConfirm}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex justify-center gap-8 mt-2">
                {s.valid && (
                  <button type="submit" className="btn btn-success">
                    Register
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
          <Footer />
        </div>
      </div>
    );
  }
}
